export default {
  el: 1,
  loadingCoupons: false,
  newCoupon: {
    loadingCreatingCoupon: false,
    loadingCouponNameCheck: false,
    couponNameExists: false,
  },
  allCoupons: {
    items: [],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: 'created_at',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
    },
  },
  couponProducts: [],
  couponSearchProducts: [],
};
